import { render, staticRenderFns } from "./BadManager.vue?vue&type=template&id=32e85b6a&scoped=true"
import script from "./BadManager.vue?vue&type=script&lang=js"
export * from "./BadManager.vue?vue&type=script&lang=js"
import style0 from "./BadManager.vue?vue&type=style&index=0&id=32e85b6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e85b6a",
  null
  
)

export default component.exports